export default __webpack_public_path__ + "static/media/logo.45cced48.svg";